import script from "./KRange.vue?vue&type=script&setup=true&lang=ts"
export * from "./KRange.vue?vue&type=script&setup=true&lang=ts"

import "./KRange.vue?vue&type=style&index=0&id=7cb1cd21&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cb1cd21"]])

export default __exports__
import QSlider from 'quasar/src/components/slider/QSlider.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QSlider});
